import store from "@/store";

export default {
  namespaced: true,
  state: {
    browser: "", //접속 브라우저
    version: "", //접속 브라우저 버전
    os: "", //접속 시스템 OS
    userAgent: "",
    initialized: false, //시스템 초기화 완료 여부
    reload: false, //새로고침여부
    pgm_data: null, //프로그램목록
    menu_data: null, //메뉴 목록
    biz_day_yn: "N", //영업일여부
    biz_sta_tm: "", //영업시작시간
    biz_end_tm: "", //영업종료시간
    notice: null, //공지사항
    lastErsLink: "", //마지막 ers 통계 연동 서비스코드(중복전송을 막기위함.)
    loading: 0, //로딩카운트 0 일때 hide 시켜준다.
    openCbtYn: "N", // 앱 챗봇 오픈 여부(app)
    openEpYn: "N", // 학습특별지원금 챗봇 오픈 여부(web)
    ersSetCbtYn: "N", // ERS에 설정된 챗봇 노출 여부
    isAliveERS: true // ERS시스템 통신가능 여부
  },
  mutations: {
    setSystem(state, si) {
      state.browser = si.browser;
      state.version = si.version;
      state.os = si.os;
    },
    setUserAgent(state, userAgent) {
      state.userAgent = userAgent;
    },
    setReload(state, isReload) {
      state.reload = isReload;
    },
    setPgmData(state, pgm_list) {
      state.pgm_data = pgm_list;
    },
    setMenuData(state, menu_list) {
      state.menu_data = menu_list;
    },
    setBizTime(state, connInfo) {
      //영업시간에 대한 정보를 설정
      state.biz_day_yn = connInfo.biz_day_yn;
      state.biz_sta_tm = connInfo.biz_sta_tm;
      state.biz_end_tm = connInfo.biz_end_tm;
    },
    setNotice(state, _notice) {
      state.notice = _notice;
    },
    setInitialized(state) {
      const custInfo = store.state.customer.conninfo;

      if (
        state.pgm_data != null &&
        state.menu_data != null &&
        custInfo != null
      ) {
        state.initialized = true;
      } else {
        state.initialized = false;
      }
    },
    setInitApp(state, value) {
      state.initialized = value;
    },
    setLastErsLink(state, svcCode) {
      state.lastErsLink = svcCode;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    // 앱챗봇 오픈 여부(챗봇과 연동)
    setOpenCbtYn(state, value) {
      state.openCbtYn = value;
    },
    // 학습특별지원금 챗봇 오픈여부(web)
    setOpenEpYn(state, value) {
      state.openEpYn = value;
    },
    // ERS에 설정된 챗봇 노출 여부(ERS와 연동)
    setErsSetCbtYn(state, value) {
      state.ersSetCbtYn = value;
    },
    // ERS시스템 통신가능 여부
    setIsAliveERS(state, value) {
      state.isAliveERS = value;
    }
  },
  actions: {},
  getters: {
    getBrowser(state) {
      return state.browser;
    },
    getVersion(state) {
      return state.version;
    },
    getOS(state) {
      return state.os;
    },
    getInitialized(state) {
      return state.initialized;
    },
    getMenuData(state) {
      return state.menu_data;
    },
    getSubMenuData: state => menu_id => {
      let submenu = null;
      state.menu_data.forEach(item => {
        if (item.menu_id === menu_id) {
          submenu = item.menu_list;
          return;
        }
      });
      return submenu;
    },
    getReload(state) {
      return state.reload;
    },
    getPgmData(state) {
      return state.pgm_data;
    },
    getBizDay: state => {
      //영엽일 여부
      return state.biz_day_yn;
    },
    getBizStaTm: state => {
      //영업시작시간
      return state.biz_sta_tm;
    },
    getBizEndTm: state => {
      //영업종료시간
      return state.biz_end_tm;
    },
    getNotice: state => {
      return state.notice;
    },
    getLastErsLink: state => {
      return state.lastErsLink;
    },
    getLoading(state) {
      //현재 로딩 수 리턴
      return state.loading;
    },
    // 앱 챗봇 오픈 여부(app)
    getOpenCbtYn: state => {
      return state.openCbtYn;
    },
    // 학습특별지원금 챗봇 오픈 여부(web)
    getOpenEpYn: state => {
      return state.openEpYn;
    },
    // ERS에 설정된 챗봇 노출 여부
    getErsSetCbtYn: state => {
      return state.ersSetCbtYn;
    },
    // ERS시스템 통신 가능 여부
    getIsAliveERS: state => {
      return state.isAliveERS;
    }
  }
};
